import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.patient-entitlement-to-medical-service': {
         entitlementStatement: 'Oświadczenie',
         euwsPasswordExpired: 'Hasło do eWUŚ wygasło. Zmień hasło w zakładce <link />.',
         ewus: 'eWUŚ',
         ewusPasswordWillExpireAtTheEndOfTheDay:
            'Z końcem dzisiejszego dnia hasło do eWUŚ wygaśnie. Zmień hasło w zakładce <link />.',
         ewusPasswordWillExpireInDays: 'Za {{days}} dni hasło do eWUŚ wygaśnie. Zmień hasło w zakładce <link />.',
         ewusPasswordWillExpireInOneDay: 'Za 1 dzień hasło do eWUŚ wygaśnie. Zmień hasło w zakładce <link />.',
         failedLoginToEwusPleaseCheckCodeFromApplicationOrYouEWUSLoginDetailsAgain:
            'Nieudane logowanie do eWUŚ. Sprawdź ponownie kod z aplikacji lub dane logowania do eWUŚ.',
         nfzLogin: 'Logowanie NFZ',
         patientEntitlementStatusMessageMap: {
            ACCOUNT_BLOCKED: 'Konto jest zablokowane w systemie eWUŚ. Spróbuj ponownie za 15 minut.',
            ACCOUNT_LOGIN_ERROR: 'Połączenie nie powiodło się. Podane dane logowania są nieprawidłowe.',
            INSURED: 'Pacjent ubezpieczony',
            PASSWORD_EXPIRED: 'Hasło wygasło. Musisz dokonać zmiany hasła.',
            UNINSURED: 'Pacjent nieubezpieczony',
            UNVERIFIED: 'Pacjent niezweryfikowany',
            UNVERIFIED_IN_FUTURE: 'Pacjent niezweryfikowany. Weryfikacja eWUŚ możliwa jedynie w dniu wizyty.',
            UNVERIFIED_WITHOUT_EXTERNAL_IDENTIFIER:
               'Pacjent niezweryfikowany. Weryfikacja eWUŚ możliwa jedynie dla pacjentów z PESEL.',
            VALID_ENTITLEMENT_STATEMENT: 'Złożono oświadczenie',
            VERIFICATION_FAILURE:
               'Problem podczas weryfikacji pacjenta w systemie eWUŚ. Sprawdź konfigurację Twojego konta eWUŚ w systemie lub spróbuj ponownie później.',
         },
         synchronization: 'Synchronizacja statusu eWUŚ...',
         unableToRetrievePatientDataFromEwus: 'Nie udało się pobrać danych pacjenta z systemu eWUŚ.',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.patient-entitlement-to-medical-service'
);
